/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
/* eslint-disable radix */
import React, { Component } from 'react';
import Loader from 'lib/loader';
import { getSelectedWeekDates, getWeekDays } from 'lib/services';
import RoutingConstants from 'lib/RoutingConstants'
import { post, get } from 'lib/api'
import moment from 'moment'
import _ from 'lodash'
import ViewMainDish from './ViewMainDish'
import ViewsSideDish from './ViewsSideDish'
import Login from '../login/Login';
import DashHeader from '../dashboard/DashHeader';
import history from '../../history'
import UpgradePlan from '../billingDetails/UpgradePlan'


class PrintPlan extends Component {
  constructor(props) {
    super(props)
    const weekStartEnd = getSelectedWeekDates('currentWeek');
    const dayDates = getWeekDays(weekStartEnd);
    const dataProps = this.props.location.state !== undefined ? this.props.location.state : {}
    const planType = this.props.location.state ? this.props.location.state.exist : 'yes';
    const slideClass = window.innerWidth < 768 ? dataProps !== undefined && dataProps && dataProps.slideClass === undefined ? 'sliderighttrue' : dataProps.slideClass : ''
    this.state = {
      dayDates,
      printPlanClass: 'active',
      reminder: false,
      inputs: {
        delete: [],
        update: [],
        add: [],
        deleted_cooking_ids: []
      },
      subscriptionPlan: [],
      planType,
      error: false,
      cookArr: [],
      recipeArr: [],
      cookingDate: [],
      servingArr: [],
      cookDayArr: [],
      lastStep: false,
      editRecipe: false,
      deleteRecipeIndex: [],
      bottomText: false,
      showCook: false,
      calories: '0',
      recipeIdArr: [],
      groceryList: [],
      customItems: [],
      showFeedbackPopup: false,
      redirectDash: false,
      slideRepeat: false,
      slideClass,
      showBillingPopup: false,
      loader: true
    };}

  componentDidMount() {
    const dataProps = this.props.location.state
    document.getElementsByTagName('body')[0].className = ''
    if (dataProps === undefined || (dataProps && dataProps.bottomBtnState === undefined) || sessionStorage.getItem('method') !== 'back') {
      let { dayDates } = this.state
      window.scrollTo(0, 0)
      dayDates = this.props.location.state && this.props.location.state.dayDates !== undefined ? this.props.location.state.dayDates : dayDates
      if(!dayDates){
        const weekStartEnd = getSelectedWeekDates('currentWeek');
        dayDates = getWeekDays(weekStartEnd);
      }      
      this.fetchPlan(dayDates)
      sessionStorage.removeItem('method')
    } else if (dataProps && sessionStorage.getItem('method') === 'back') {
      const slideClass = window.innerWidth < 768 ? 'dashslideleft' : ''
      this.useHistoryData(dataProps, slideClass)
    }}
    
  getWeekData(dayDates, selectedWeek) {
    const { inputs, slideRepeat } = this.state
    inputs.delete = []
    inputs.update = []
    inputs.add = []
    inputs.deleted_cooking_ids = []
    let slide;
  
    if (selectedWeek === 'nextWeek' && window.innerWidth < 768) {
      slide = `slideleft${slideRepeat}`
      // slide= 'slidetest'
    } else if (selectedWeek === 'previousWeek' && window.innerWidth < 768) {
      slide = `slideright${slideRepeat}`
      // slide= '`slideleft${slideRepeat}`'
    }
    this.setState({ recipeArr: [], cookingDate: [], inputs, loader: true, slideClass: slide, slideRepeat: !slideRepeat })
    this.fetchPlan(dayDates)
  }
    
  fetchPlan(dayDates) {
    const { servingArr, deleteRecipeIndex, cookDayArr, recipeArr, cookingDate } = this.state
    const { cookArr } = this.state
    const url = RoutingConstants.getNewPlan;
    const { inputs } = this.state
    const startDate = `${dayDates[0].Year}-${dayDates[0].Month}-${dayDates[0].date}`;
    const endDate = `${dayDates[6].Year}-${dayDates[6].Month}-${dayDates[6].date}`;
    inputs.week_start_date = startDate;
    inputs.week_end_date = endDate;
    inputs.user_weekly_schedule_id = ''
    post(url, inputs).then(response => {
      // const data = response.result.userWeeklyScheduleData
      if (response.result.userWeeklyScheduleId)
        inputs.user_weekly_schedule_id = response.result.userWeeklyScheduleId
      if(response.result && response.result.trials_end_at !== null) {
        this.showBillingPopup(response.result.trials_end_at)
      }

      let recipes = 0
      response.result.recipeIdsArray.map(ids=>{
        if(recipes === 0) {
          recipes=ids
        } else {
          recipes += `,${ids}`
        }
        return null
      })
      const contRecipe = `${RoutingConstants.contentfulRecipe}${recipes}`
      get(contRecipe,'contentful').then(result=>{
        response.result.meal_plan.map(item => {
          // const dDate = moment(item.cooking_date).format('DD')
          // const day = dayDates.findIndex(x=>x.date === dDate)
          // mealDay.push({ cooking_date: item.cooking_date, recipe: [], cooking_day: dayDates[day].day })
          // const len = mealDay.length - 1
              
          item.recipe.map(rcp=>{
            const resIndex = result.items.findIndex(x=>x.sys.id === rcp.recipe_id)
            if(resIndex > -1){
                
                
              if(result.items[resIndex].fields.recipeSides && result.items[resIndex].fields.recipeSides.length > 0 ) {
                const sideIndex = result.items.findIndex(x=>x.sys.id === result.items[resIndex].fields.recipeSides[0].sys.id )
                
                if(sideIndex > -1) {
                  result.items[resIndex].fields.sideRecipe = result.items[sideIndex].fields
                  result.items[resIndex].fields.sideRecipe.sideId = result.items[sideIndex].sys.id
                  if( result.items[sideIndex].fields &&  result.items[sideIndex].fields.image){
                    const sideimageIndex = result.includes.Asset.findIndex(x=>x.sys.id === result.items[sideIndex].fields.image.sys.id)
                    if(sideimageIndex > -1) {
                      result.items[resIndex].fields.sideRecipe.recipeImage = `https:${result.includes.Asset[sideimageIndex].fields.file.url}`
                    }
                  }

                  result.items[resIndex].fields.sideRecipe.recipeIngredient = []
                  result.items[resIndex].fields.recipeIngredient = this.recipeIngredient(
                    result.items[resIndex].fields.sideRecipe.ingredientsData, result.items[resIndex].fields.sideRecipe.recipeIngredient, result
                  )

                  result.items[resIndex].fields.sideRecipe.recipeInstruction = []
                  result.items[resIndex].fields.sideRecipe.recipeInstruction = this.recipeInstruction(
                    result.items[resIndex].fields.sideRecipe.instructions, result.items[resIndex].fields.sideRecipe.recipeInstruction, result)

                  
                }
              }
              
              result.items[resIndex].fields.recipeInstruction = []
              result.items[resIndex].fields.recipeInstruction = this.recipeInstruction(
                result.items[resIndex].fields.instructions, result.items[resIndex].fields.recipeInstruction, result)
              

              result.items[resIndex].fields.recipeIngredient = []
              result.items[resIndex].fields.recipeIngredient = this.recipeIngredient(
                result.items[resIndex].fields.ingredientsData, result.items[resIndex].fields.recipeIngredient, result
              )
              
                
              
                
              result.items[resIndex].fields.equipmentIcon = `/images/none.svg`
              if(result.items[resIndex].fields.equipmentTypes){
                const equipIndex = result.includes.Entry.findIndex(x=>x.sys.id=== result.items[resIndex].fields.equipmentTypes[0].sys.id)
                if(equipIndex > -1) {
        
                  result.items[resIndex].fields.equipmentIcon = `/images/${result.includes.Entry[equipIndex].fields.icon}`
                  // result.items[resIndex].fields.equipmentName = result.includes.Entry[equipIndex].fields.title
                } 
              }
              let sideId = result.items[resIndex].fields.sideRecipe ? result.items[resIndex].fields.sideRecipe.sideId : null
              let recipeSides = result.items[resIndex].fields.sideRecipe ? result.items[resIndex].fields.sideRecipe : null
              const rIndex = recipeArr.findIndex(x=>x.recipe_id === result.items[resIndex].sys.id)
          
              if(item.cooking_date === rcp.meal_plan_date){
                let sideServing = rcp.recipe_serving_size
                if(sideId) {
                  const sideIndex = recipeArr.findIndex(x=>x.sideId === sideId)
                  if(sideIndex > -1) {
                    recipeArr[sideIndex].side_serving_size += rcp.recipe_serving_size
                    sideServing += recipeArr[sideIndex].side_serving_size
                    sideId = null
                    recipeSides = null
                  }
                }
                if(rIndex === -1){
                  recipeArr.push({ 
                    recipe: result.items[resIndex].fields, 
                    recipe_id: result.items[resIndex].sys.id, 
                    serving_size: rcp.recipe_serving_size, 
                    side_serving_size: sideServing, 
                    sideRcp: recipeSides, 
                    sideId, 
                  })}
                else {
                  recipeArr[rIndex].serving_size += rcp.recipe_serving_size
                }}
                
             
            }
             
            return null;
          })
          return  null;
        })
        this.setState({
          cookArr, recipeArr, cookingDate, lastStep: true, servingArr,
          deleteRecipeIndex, cookDayArr, inputs, dayDates, error: false,
          recipeIdArr: [], defaultServingSize: response.result.serving_size, loader: false
        })
      })
      // response.result.meal_plan.map(item=>{
      //   item.recipe.map((rcp)=>{
      //     let sideId = rcp.recipe_sides ? rcp.recipe_sides.id : null
      //     let recipeSides = rcp.recipe_sides ? rcp.recipe_sides : null
      //     const rIndex = recipeArr.findIndex(x=>x.recipe_id === rcp.recipe.id)
          
      //     if(item.cooking_date === rcp.meal_plan_date){
      //       let sideServing = rcp.recipe_serving_size
      //       if(sideId) {
      //         const sideIndex = recipeArr.findIndex(x=>x.sideId === sideId)
      //         if(sideIndex > -1) {
      //           recipeArr[sideIndex].side_serving_size += rcp.recipe_serving_size
      //           sideServing += recipeArr[sideIndex].side_serving_size
      //           sideId = null
      //           recipeSides = null
      //         }
      //       }
      //       if(rIndex === -1)
      //         recipeArr.push({ 
      //           recipe: rcp.recipe, 
      //           recipe_id: rcp.recipe.id, 
      //           serving_size: rcp.recipe_serving_size, 
      //           side_serving_size: sideServing, 
      //           sideRcp: recipeSides, 
      //           sideId, 
      //         })
      //       else {
      //         recipeArr[rIndex].serving_size += rcp.recipe_serving_size
      //       }}
      //     return rcp;
      //   })
      //   return item
      // })

      
    }).catch((err) => {
      if(err.result && err.result.trials_end_at !== null) {
        this.showBillingPopup(err.result.trials_end_at)
      }
      this.catchError(err, dayDates)
    })

  }

  catchError(err, dayDates) {
    let defaultServingSize = 2
    if (err.error === 'token_expired') {
      localStorage.removeItem('token');
      history.push('/login', { location: this.state.location });
    }
    if (err.result && err.result.serving_size) {
      defaultServingSize = err.result.serving_size
    }
    this.setState({ error: true, dayDates, defaultServingSize, loader: false })
  }

  

  // billing popup
  showBillingPopup(trialDate) {
    const startDate = moment()
    const endDate = moment(trialDate)
    
    const result = endDate.diff(startDate,'days')
    if(result < 0){
      
      this.setState({ showBillingPopup: true})
    }
  }

  // eslint-disable-next-line
  recipeInstruction(data,recipeInsData, result) {
    // return(
    data.map(inst=>{
      const insIndex = result.includes.Entry.findIndex(x=>x.sys.id=== inst.sys.id)
      if(insIndex > -1) {
        recipeInsData.push({instruction: result.includes.Entry[insIndex].fields.instructionText, id: inst.sys.id})
      }
      return null;
    })
    // )
    return recipeInsData
  }

  // eslint-disable-next-line
  recipeIngredient(data,recipeIndData, result) {
    // const { groceryCategory } = this.state
    data.map(ingd=>{
      const ingIndex = result.includes.Entry.findIndex(x=>x.sys.id === ingd.sys.id)
      if((ingIndex > -1) ) {

        const ingNameIndex = result.includes.Entry.findIndex(x=>x.sys.id === result.includes.Entry[ingIndex].fields.ingredient.sys.id)
        if(ingNameIndex > -1){
          let unit = result.includes.Entry[ingIndex].fields.unit
          unit = unit === 'empty' ? null : unit
          recipeIndData.push({ 
            quantity: result.includes.Entry[ingIndex].fields.quantity, 
      
            id: ingd.sys.id, 
            unit,
            ingredient:{
              name:result.includes.Entry[ingNameIndex].fields.name,
            }
          })
        }
      }
      return ingd;
    })
    return recipeIndData
  }

  render() {
    const recipeData = this.state.recipeArr;
    const { showBillingPopup } = this.state
    
    const showRecipeData = recipeData.map((res, index) => {
      console.log(recipeData)
      const mainDish = <ViewMainDish
        // type={this.state.viewRecipeData.type}
        response={res.recipe}
        servingSize={res.serving_size}
        {...this.state}
        // eslint-disable-next-line react/no-array-index-key
        key={index}
      />

      let setsideDish = '';
      if (res.sideRcp) {
        setsideDish =
          <ViewsSideDish
            response={res.sideRcp}
            sid={res.sideId}
            // length={res.items.recipe.recipe_sides.length}
            sideDishValue={res.sideRcp}
            servingSize={res.side_serving_size}
            {... this.state}
            // key={sideIndex}
          />
        // });
      }
      const fullHtml = _.concat(mainDish, setsideDish);
      return <div key={index} className='break-before'>{fullHtml}</div>;
    })


    const {
      dayDates, reminder, subscriptionPlan, planType, error,
      loader, slideClass
    } = this.state;
    if (!this.props.location.state && localStorage.type === 'checkUser') {
      localStorage.removeItem('token');
      return <Login location='/dashboard' />;
    }
    return (
      <div className={`wrapper printPlan ${slideClass}`} >
        <title> Prep Day - Print Recipes </title>
        <style>
          {`
          @media(min-width:320px) and (max-width:767px){
          #PureChatWidget.purechat.purechat-image-only.purechat-widget-collapsed.purechat-bottom-right .purechat-collapsed-image, #PureChatWidget.purechat.purechat-image-only.purechat-widget-collapsed.purechat-top-right .purechat-collapsed-image{
            left:5px !important; right: auto !important;
          }
          #PureChatWidget.purechat.purechat-widget-collapsed{
            left: 20px important;
            right: auto !important;
            top: 15px !important;
          }
        }
          `}
        </style>
        {
          loader &&
            <div className="loading">
              <Loader />
              <div className="modal-backdrop fade in" />
            </div>
        }
        <div className="mb-hide dashheader">
          <DashHeader
            dashClass={this.state.dashClass}
            groceryClass={this.state.groceryClass}
            printPlanClass="active"
            dayDates={dayDates}
            subscriptionPlan={subscriptionPlan}
            previous={this.state.previous}
            planExist={planType}
            reminder={reminder}
            error={error}
            resetPln={()=>this.resetPlan()}
            buildPlan={(weekDate)=>this.createPlan(weekDate)}
            getWeekData={(dayDate, selectedWeek, previousDat)=>this.getWeekData(dayDate, selectedWeek, previousDat)}
          />
        </div>
        { showBillingPopup &&
          <div>
            <UpgradePlan 
              onClose={()=>this.closeBillingPopup()}
              dashClass={this.state.dashClass}
              groceryClass={this.state.groceryClass}
              dayDates={dayDates}
              subscriptionPlan={subscriptionPlan}
              previous={this.state.previous}
            />
            <div className="modal-backdrop fade in mb-only" />
          </div>
        }
        <section className="printPlanOuterContainer">
          <div className="printPlanInnerContainer">
            <div className="container">
              {
                showRecipeData
              }       
            </div>
          </div>
        </section>

      </div>
    );
  }
}
export default PrintPlan;



// WEBPACK FOOTER //
// ./src/components/printPlan/PrintPlan.js